import React, { useState, useEffect } from "react";
import "./Inner_Description.css";
import { BlogById } from "../../../../utils/apis/blog/Blog";

const Inner_Description = ({ blogId }) => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [indescription, setInDescription] = useState("");

  const getInDescription = async () => {
    const res = await BlogById(blogId);

    if (res?.success) {
      setInDescription(res?.data?.description || "");
    }
  };

  useEffect(() => {
    if (blogId) {
      getInDescription();
    }
  }, [blogId]);

  return (
    <section className="Inner_Description">
      {/* <div className="Inner_Description_header_holder">
        <p className="Inner_Description_header">
          With rising operational complexities, frequent system downtime, and
          growing security concerns, modern enterprises are actively looking for
          smarter and more sustainable infrastructure solutions. The era of
          relying entirely on legacy, unoptimized local servers is quickly
          shifting. Cloud automation and managed IT frameworks have emerged as
          one of the most practical and rewarding investments for businesses
          globally. Scaling your infrastructure efficiently is no longer just a
          tech trend—it is a critical, long-term operational decision. Here is
          why upgrading your enterprise system with a modern, automated cloud
          architecture is the smartest choice you can make today.
        </p>
      </div> */}

      <div className="Inner_Description_benefits">
        {/* <div key={item.id} className="benefit_item pb-2"> */}
        <h5 className="benefit_title">
          {/* <span>{item.id}.</span> {item.title} */}
        </h5>
        <p className="benefit_text">{htmlToReactParser.parse(indescription)}</p>
        <hr />
      </div>

      {/* </div> */}
    </section>
  );
};

export default Inner_Description;
